import React from 'react'
import moment from 'moment'
import _ from 'lodash'
import { Dimmer, Loader } from 'semantic-ui-react'

import DateFields from '../fields/dateFields'
import OrderStatistic from './orderStatistic'
import DriverStatistic from './driverStatistic'
import LineCharts from './lineCharts'
import LifeSpanList from './lifeSpanList'
import DriverPerformanceList from './driverPerformanceList'

import utils from '../../../utils'

export default class DriverAnalytics extends React.Component {
  constructor() {
    super()

    this.state = {
      startFrom: Number(
        moment()
          .startOf('day')
          .format('x')
      ),
      endAt: Number(
        moment()
          .endOf('day')
          .format('x')
      ),
      allTimeSlot: {
        online: {},
        offline: {},
      },
      drivers: {},
    }
  }

  componentDidMount() {
    const { allActivities, drivers } = this.props

    this.setState({ drivers })

    if (_.size(allActivities) > 0) {
      this.initTimeSlot(allActivities)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { allActivities } = this.props

    if (nextProps.allActivities !== allActivities && nextProps.allActivities) {
      this.initTimeSlot(nextProps.allActivities)
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { allActivities, analyticLoading, driverLoading } = this.props
    return (
      allActivities !== nextProps.allActivities ||
      analyticLoading !== nextProps.analyticLoading ||
      driverLoading !== nextProps.driverLoading ||
      this.state !== nextState
    )
  }

  initTimeSlot = allActivities => {
    let onlineTimeSlot = {}
    let offlineTimeSlot = {}
    _.map(allActivities, activity => {
      if (activity.onlined_at) {
        const formatedTime = this.getHourFromTimestamp(activity.onlined_at)
        onlineTimeSlot = this.assignTimeslot(onlineTimeSlot, formatedTime)
      }
      if (activity.offlined_at) {
        const formatedTime = this.getHourFromTimestamp(activity.offlined_at)
        offlineTimeSlot = this.assignTimeslot(offlineTimeSlot, formatedTime)
      }
    })

    this.setState({
      allTimeSlot: {
        online: onlineTimeSlot,
        offline: offlineTimeSlot,
      },
    })
  }

  validateSearchByDate = () => {
    const { startFrom, endAt } = this.state

    if (startFrom > endAt) {
      return false
    }

    return true
  }

  getOrderByDate = () => {
    const { startFrom, endAt } = this.state
    const { getAnalyticOrders } = this.props

    getAnalyticOrders(startFrom, endAt)
  }

  onFieldChange = (field, value) => {
    let newValue = value

    if (field === 'startFrom') {
      newValue = moment(value)
        .startOf('day')
        .format('x')
    } else {
      newValue = moment(value)
        .endOf('day')
        .format('x')
    }
    this.setState({ [field]: Number(newValue) })
  }

  onSearch = () => {
    const valid = this.validateSearchByDate()

    if (valid) {
      this.getOrderByDate()
    } else {
      alert('Date invalid, please check it again')
    }
  }

  renderLoading = () => {
    return (
      <Dimmer active inverted>
        <Loader inverted />
      </Dimmer>
    )
  }

  renderContent = () => {
    const { allTimeSlot, startFrom, endAt } = this.state
    const { analyticLoading, analyticOrders } = this.props

    const dateLength = moment(endAt).diff(moment(startFrom), 'days') + 1

    const rowsTimeSlotData = utils.helpers.getRowsTimeSlot(allTimeSlot, analyticOrders)
    const driverStats = utils.helpers.getDriverStatistic(analyticOrders, dateLength)

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <div style={{ padding: '0px 14px' }}>
          <DateFields
            loading={analyticLoading}
            startFrom={startFrom}
            endAt={endAt}
            onSearch={this.onSearch}
            onFieldChange={this.onFieldChange}
          />
        </div>
        <div
          style={{
            height: '100%',
            overflow: 'auto',
            padding: '14px 14px 0px 14px',
          }}
          className="list-content"
        >
          <OrderStatistic orders={analyticOrders} />
          <DriverStatistic {...driverStats} />
          <DriverPerformanceList startFrom={startFrom} endAt={endAt} orders={analyticOrders} />
          <LineCharts {...rowsTimeSlotData} />
          <LifeSpanList {...rowsTimeSlotData} />
        </div>
      </div>
    )
  }

  render() {
    const { driverLoading } = this.props
    const { drivers } = this.state

    if (driverLoading || !drivers) {
      return this.renderLoading()
    }

    if (drivers) {
      return this.renderContent()
    }

    return null
  }

  getHourFromTimestamp = timestamp => {
    const convertedTimestamp = parseInt(timestamp, 10)
    const formatTime = moment(convertedTimestamp).format('H')
    return formatTime
  }

  assignTimeslot = (timeslot, time) => {
    if (timeslot[time]) {
      timeslot[time] = {
        count: timeslot[time].count + 1,
      }
    } else {
      timeslot[time] = { count: 1 }
    }

    return timeslot
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/views/analytics.js